import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { QueryErrorHandler } from '../query-error-handler/query-error-handler';
import styles from './definition-list.module.scss';

type Props = {
  title: string;
  children: ReactNode;
  error?: React.ComponentProps<typeof QueryErrorHandler>['error'];
  debugInfo?: React.ComponentProps<typeof QueryErrorHandler>['debugInfo'];
  wide?: boolean;
};

export const DefinitionList: React.FC<Props> = ({ title, children, error, debugInfo, wide = false }) => {
  return (
    <div>
      <Typography className={styles.definitionTitle} variant="headline-3">
        {title}
      </Typography>
      <QueryErrorHandler debugInfo={debugInfo} error={error}>
        <dl className={classNames(styles.root, { [styles.wide]: wide })}>{children}</dl>
      </QueryErrorHandler>
    </div>
  );
};
